import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { serverUrl } from './serverurl';


@Injectable({
  providedIn: 'root'
})
export class SpecialCategoryService {

  constructor(private http: HttpClient) { 

  }

  // saveQuestion(questionCode: string, questionRequest: QuestionRequest) {
  //         return this.http.post<ApiResponse<OcrStatus>>(serverUrl + "registration-step/" + questionCode, questionRequest);
  //     }


      // fetch dropdown options
  getOptions(): Observable<any[]> {
    return this.http.get<any[]>(serverUrl + "api/special-category/options");
  }

  //  // save user selection
  // saveSelection(selection: any): Observable<any> {
  //   return this.http.post<SpecialDocumentUploadRequest>(serverUrl + "/api/special-category/select");
  // }

  // get already selected categories
  getSelections(regId: number): Observable<any[]> {
    return this.http.get<any[]>(serverUrl + "api/special-category/selected/{regId}s");
  }
}

